angular.module('impactx.productcoding').controller('ProductGroupEditPriceDialogCtrl', ['$scope', '$mdDialog', 'TranslationService',
    'themeFactory', 'dataGen', 'ToastService',
    ProductGroupEditPriceDialogCtrl]);

function ProductGroupEditPriceDialogCtrl($scope, $mdDialog, TranslationService, themeFactory, dataGen, ToastService)
{
    $scope.saveLabel = TranslationService.get("save");
    $scope.abortLabel = TranslationService.get("abort");
    $scope.deleteLabel = TranslationService.get("delete");
    $scope.requiredLabel = TranslationService.get("required");
    $scope.closeLabel = TranslationService.get("close");
    $scope.theme = themeFactory.getTheme();

    var self = this;
    self.requestInProgress = false;
    self.cancel = function() {
        $mdDialog.cancel();
    };

    self.addPriceRule = function () {
        self.requestInProgress = true;
        dataGen.postAsForm({}, {data: $scope.data}, "/productgroup/pricerule/add").then(function (data) {
            $scope.data.existingPriceRules = data.data.existingPriceRules;
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            self.requestInProgress = false;
            $mdDialog.hide();
        }).finally(function () {
            self.requestInProgress = false;
        });
    };

    self.deletePriceRule = function () {
        self.requestInProgress = true;
        dataGen.postAsForm({}, {data: $scope.data}, "/productgroup/pricerule/delete").then(function (data) {
            $scope.data.existingPriceRules = data.data.existingPriceRules;
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $mdDialog.hide();
        }).finally(function () {
            self.requestInProgress = false;
        });
    };

    self.noPriceRule = function () {
        self.requestInProgress = true;
        dataGen.postAsForm({}, {data: $scope.data}, "/productgroup/pricerule/norule").then(function (data) {
            $scope.data.existingPriceRules = data.data.existingPriceRules;
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $mdDialog.hide();
        }).finally(function () {
            self.requestInProgress = false;
        });
    };

    dataGen.getData($scope, {catId: self.catId, vcatId: self.vcatId, prgId: self.prgId, superPrgId: self.superPrgId}, "/productgroup/view/price");
}